import { Droplets, Clock, Camera, Award, Thermometer, DollarSign } from "lucide-react";

const LICENSE_URL = "https://newjersey.mylicense.com/verification/Search.aspx?facility=Y";

const reasons = [
  {
    icon: Clock,
    title: "35+ Years Experience",
    description: "Family business started in Totowa, still family-owned. Three generations of masonry expertise.",
  },
  {
    icon: Thermometer,
    title: "Knows North Jersey Conditions",
    description: "We understand freeze-thaw cycles, clay soil, and salt damage. We build for our climate.",
  },
  {
    icon: Award,
    title: "Licensed & Insured",
    description: (<>NJ HIC License <a href={LICENSE_URL} target="_blank" rel="noopener noreferrer" className="hover:text-secondary transition-colors underline">#13VH06777200</a>. Fully licensed and insured for your peace of mind.</>),
  },
  {
    icon: DollarSign,
    title: "No Surprise Bills",
    description: "Clear quotes and upfront communication. You'll know exactly what you're paying for.",
  },
  {
    icon: Droplets,
    title: "Drainage-First Approach",
    description: "Water is the #1 reason masonry fails. We design drainage into every project, not as an afterthought.",
  },
  {
    icon: Camera,
    title: "Warranty-Backed",
    description: "We photograph every layer. Our warranty means something because we build it right the first time.",
  },
];

export function WhyUsSection() {
  return (
    <section id="why-us" className="py-24 bg-card">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            Why North Jersey <span className="text-gradient-gold">Trusts Masonry Pro</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We don't just build masonry. We build it to last for generations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {reasons.map((reason) => (
            <div
              key={reason.title}
              className="flex gap-5 p-6 rounded-xl bg-background border border-border hover:border-secondary/30 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-14 h-14 rounded-full bg-gradient-gold flex items-center justify-center shadow-gold">
                <reason.icon className="h-7 w-7 text-secondary-foreground" />
              </div>
              
              <div>
                <h3 className="text-xl font-bold mb-2">{reason.title}</h3>
                <p className="text-muted-foreground text-sm">{reason.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
